<script lang="ts">
  import { store } from '$lib/store.svelte';
  import { ESTADOS, type EstadoIdea, type Idea } from '$lib/idea';
  import IdeaCard from '../components/IdeaCard.svelte';
  import IdeaModal from '../components/IdeaModal.svelte';

  interface Props { onMessage: (m: string, t?: 'success' | 'warning') => void }
  let { onMessage }: Props = $props();

  let estado = $state<EstadoIdea>('capturada');
  let q = $state('');
  let abierta = $state<Idea | null>(null);

  const lista = $derived(
    store.ideas
      .filter((i) => i.estado === estado)
      .filter((i) => !q || (i.texto + ' ' + i.notas + ' ' + i.tags.join(' ')).toLowerCase().includes(q.toLowerCase()))
      .sort((a, b) => b.updatedAt - a.updatedAt)
  );
</script>

<div class="view-title">Embudo de ideas</div>
<div style="display:flex;gap:var(--space-xs);flex-wrap:wrap;margin-bottom:var(--space-md)">
  {#each ESTADOS as e}
    <button type="button" class="btn {estado === e ? 'btn-primary' : 'btn-secondary'}" onclick={() => (estado = e)}>
      {e} ({store.ideas.filter((i) => i.estado === e).length})
    </button>
  {/each}
</div>
<input class="form-input" placeholder="Buscar…" bind:value={q} style="margin-bottom:var(--space-md)" />

{#if lista.length === 0}
  <div class="empty"><div class="empty-title">Nada en {estado}</div></div>
{:else}
  {#each lista as idea (idea.id)}<IdeaCard {idea} onOpen={(i) => (abierta = i)} />{/each}
{/if}

{#if abierta}
  <IdeaModal idea={abierta} onClose={() => (abierta = null)} onError={(m) => onMessage(m, 'warning')} />
{/if}
